import { createContext, useContext } from 'react';
import { noop } from 'utils/fp';
import { HomeCardId, HomeCardIds } from './constants';

export type ConfigureHomeCardType = {
  configIdx: number;
  idx: number;
  id: HomeCardId;
  visible: boolean;
};

export type ConfigureHomeContextType = {
  isAnimating: boolean;
  cards: ConfigureHomeCardType[];
  moveCardTo: (id: HomeCardId, pos: number) => void;
  moveCardUp: (id: HomeCardId) => void;
  moveCardDown: (id: HomeCardId) => void;
  setCardVisibility: (id: HomeCardId, visible: boolean) => void;
};

const DEFAULT_VISIBLE_CARD_IDS_LOGGED_IN = new Set([
  HomeCardId.NewFeatures,
  HomeCardId.RecentActivity,
  HomeCardId.TrendingModels,
  HomeCardId.Compute,
  HomeCardId.MyCompute,
  HomeCardId.Quickstart,
  HomeCardId.Docs,
  HomeCardId.MyApps,
]);

const DEFAULT_VISIBLE_CARD_IDS_NON_LOGGED_IN = new Set([
  HomeCardId.NewFeatures,
  HomeCardId.TrendingModels,
  HomeCardId.Compute,
  HomeCardId.Quickstart,
  HomeCardId.Docs,
]);

export const ConfigureHomeContext = createContext<ConfigureHomeContextType>({
  isAnimating: false,
  cards: getDefaultLayout(false),
  moveCardTo: noop,
  moveCardUp: noop,
  moveCardDown: noop,
  setCardVisibility: noop,
});

export function getDefaultLayout(isLoggedIn: boolean): ConfigureHomeCardType[] {
  const defaultHomeCardVisibilitySet = isLoggedIn ? DEFAULT_VISIBLE_CARD_IDS_LOGGED_IN : DEFAULT_VISIBLE_CARD_IDS_NON_LOGGED_IN;

  return HomeCardIds.map((id, idx) => ({
    id,
    idx,
    configIdx: idx,
    visible: defaultHomeCardVisibilitySet.has(id),
  }));
}

export function useConfigureHome() {
  return useContext(ConfigureHomeContext);
}

export const HOME_PAGE_LAYOUT_STORAGE_KEY = 'homePageLayout';
